import React from 'react';
import '../css/MissionSection.css';


function MissionSection() {
  return (
    <section className="mission-section" id="mision">
      <h2 className="section-title">Misión, Visión y Valores</h2>
      <div className="mission-grid">
        <div className="mission-card">
          <h3>🌶️ Misión</h3>
          <p>
            Ofrecer salsas artesanales de chile cabrón, elaboradas con pasión y tradición nicaragüense, que reflejen el auténtico sabor picante de nuestra tierra. Nos comprometemos a brindar un producto accesible, de alta calidad y con identidad propia, llevando a cada mesa un toque único de Managua.
          </p>
        </div>
        <div className="mission-card">
          <h3>🌎 Visión</h3>
          <p>
            Convertirnos en una marca reconocida a nivel nacional e internacional por el sabor auténtico, la calidad y la nobleza que caracteriza nuestras salsas. Queremos que cada persona que pruebe nuestra salsa, conozca también el espíritu emprendedor de Nicaragua.
          </p>
        </div>
        <div className="mission-card">
          <h3>💡 Valores</h3>
          <ul className="mission-values">
            <li><strong>Pasión por lo nuestro:</strong> defendemos los sabores tradicionales con orgullo.</li>
            <li><strong>Accesibilidad:</strong> calidad para todos, sin precios excesivos.</li>
            <li><strong>Compromiso social:</strong> impulsamos el desarrollo local y la cultura nicaragüense.</li>
            <li><strong>Honestidad:</strong> cada frasco lleva la verdad de nuestros ingredientes.</li>
            <li><strong>Visión emprendedora:</strong> creemos en crecer sin olvidar nuestras raíces.</li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default MissionSection;
